import Link from './Link';
import withIntl from './withIntl';
import { languages, localeData } from './locales';

export { Link, withIntl, languages, localeData };
